    // VideoInfoPanel.jsx
import React from "react";

export function VideoInfoPanel({ title, position, roleText, strengths, description, otherVideos, onSelectOther }) {
  return (
    <div className="w-full">
      <h1 className="text-xl sm:text-2xl font-semibold tracking-tight mb-3 sm:mb-4">
        {title}
      </h1>

      <div className="space-y-3 sm:space-y-4 text-sm leading-relaxed">
        <div>
          <span className="font-semibold">Position: </span>
          <span className="text-slate-200">{position}</span>
        </div>

        {roleText && (
          <div>
            <div className="font-semibold mb-1">My role:</div>
            <p className="text-slate-300">{roleText}</p>
          </div>
        )}

        {strengths && (
          <div>
            <div className="font-semibold mb-1">Strengths:</div>
            <p className="text-slate-300">{strengths}</p>
          </div>
        )}

        <div className="pt-2">
          <div className="font-semibold mb-1">Video Description</div>
          <p className="text-slate-300 line-clamp-3 lg:line-clamp-none">{description}</p>
        </div>
      </div>

      {otherVideos && otherVideos.length > 0 && (
        <div className="mt-6 sm:mt-8">
          <h3 className="text-sm font-semibold mb-3">Other Videos</h3>
          <div className="flex gap-3 sm:gap-4 overflow-x-auto pb-2">
            {otherVideos.map((video) => (
              <button
                key={video.id}
                onClick={() => onSelectOther?.(video)}
                className="w-24 sm:w-32 flex-shrink-0 text-left group"
              >
                <div className="relative overflow-hidden rounded-md border border-slate-700 bg-slate-900/40 aspect-[4/5]">
                  {video.thumbnail ? (
                    <img
                      src={video.thumbnail}
                      alt={video.title || ""}
                      className="h-full w-full object-cover group-hover:scale-[1.03] transition-transform"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  ) : video.src ? (
                    <video
                      src={video.src}
                      className="h-full w-full object-cover group-hover:scale-[1.03] transition-transform pointer-events-none"
                      preload="metadata"
                      muted
                      playsInline
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  ) : (
                    <div className="h-full w-full flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-800">
                      <svg className="w-12 h-12 text-slate-500" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
                      </svg>
                    </div>
                  )}
                  <div className="absolute inset-0 flex items-center justify-center bg-black/25 opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="h-8 w-8 sm:h-10 sm:w-10 rounded-full bg-white/90 flex items-center justify-center text-black text-xs sm:text-base">
                      ▶
                    </div>
                  </div>
                </div>
                <p className="mt-2 text-[10px] sm:text-[11px] text-slate-400 truncate">
                  {video.date}
                </p>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
